import { useQuery } from '@tanstack/react-query'
import { CHURCHES } from '../constants/endpoints'
import { getChurches } from '../utils/getChurches'
import { useAuthStore } from '@/features/auth/store/authStore'

export const useChurchesQuery = ({ enabled }: { enabled: boolean }) => {
  const userId = useAuthStore((state) => state.user?._id)

  return useQuery({
    queryKey: [CHURCHES, userId],
    queryFn: getChurches,
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  })
}
